import { hasBannedCharacters } from '../../lib/validation/text_validation';
import { isValidBaseReferenceArray } from './base.validator';

/**
 * Validates a group ID string by ensuring it is non-empty and does not contain banned characters.
 * @param {string} group_id The group ID string to validate.
 * @returns {boolean} `true` if the group ID is valid, `false` otherwise.
 */
export const isValidGroupId = (group_id: unknown): boolean =>
  typeof group_id === 'string' &&
  !!(
    group_id &&
    !hasBannedCharacters(group_id, {
      banned_characters: '0123456789 .()&$+%@'
    })
  );

/**
 * Validates a group name string by ensuring it is non-empty and does not contain banned characters.
 * @param {string} group_name The group name string to validate.
 * @returns {boolean} `true` if the group name is valid, `false` otherwise.
 */
export const isValidGroupName = (group_name: unknown): boolean =>
  !!(
    group_name &&
    typeof group_name === 'string' &&
    !hasBannedCharacters(group_name, {
      banned_characters: '0123456789,.()&$+%@'
    })
  );

/**
 * Validates an array of group sectors, allows for none.
 * @param {Array<unknown>} sectors The group sectors array to validate.
 * @returns {boolean} `true` if the group sectors are valid, `false` otherwise.
 */
export const isValidGroupSectors = (sectors: unknown): boolean =>
  Array.isArray(sectors) && isValidBaseReferenceArray(sectors, true);
